module.exports = __webpack_public_path__ + "img/verticalSpacingWhite.f942802b.svg";